/* eslint-disable eqeqeq */
import Vue from 'vue'
import moment from 'moment'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  max,
  min,
  required,
  required_if,
  integer,
  confirmed,
  email,
  between
  // max_value
} from 'vee-validate/dist/rules'
import { isValidPhoneNumber } from 'libphonenumber-js'

/*
extend('max', {
  validate: (value, { length }) => value && value.length <= length,
  params: ['length'],
  message: '{_field_}는 {length}자를 초과할 수 없습니다.',
});
*/
// extend('valid_password', {
//   validate: value => {
//     var regExp = new RegExp(
//       '^(?=.*[a-z])(?=.*\\d)(?=.*[~!@#$%\\^\\*\\-_=\\+\\[\\{\\]\\}\\/;:,\\.\\?\\\'\\"\\(\\)&])[A-Za-z\\d~!@#\\$%\\^\\*-_=\\+\\[\\{\\]\\}\\/;:,\\.\\?\\\'\\"\\(\\)&]{8,20}$'
//     )
//     return !!regExp.test(value)
//   },
//   message: '비밀번호는 영문 소문자 + 숫자 + 기호의 조합으로 8자 ~ 20자입니다.'
// })
// extend('valid_id', {
//   validate: value => {
//     var regExp = /^[a-z0-9]*$/
//     return !!regExp.test(value)
//   },
//   message: 'ID 생성 규칙에 맞지 않는 데이터입니다.'
// })
extend('between', {
  ...between,
  message: '{_field_} có giá trị trong khoảng {min} và {max}.'
})
extend('max', {
  ...max,
  message: '{_field_} có độ dài tối đa {length} kí tự.'
})
extend('min', {
  ...min,
  message: '{_field_} có độ dài tối thiểu {length} kí tự.'
})
extend('required', {
  ...required,
  message: '{_field_} bắt buộc phải nhập.'
})
extend('required_if', {
  ...required_if,
  message: '{_field_} bắt buộc phải nhập.'
})
extend('requiredMsg', {
  ...required,
  message: '{_field_}'
})
extend('no_special', {
  validate: value => {
    var regExp = /[ `! @#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/
    return !regExp.test(value)
  },
  message: '{_field_} chứa kí tự đặc biệt và dấu cách.'
})
extend('tax', {
  validate: value => {
    var regExp = /^[0-9-]+$/
    return regExp.test(value)
  },
  message: '{_field_} chỉ cho phép số và dấu gạch ngang (-).'
})
extend('fax', {
  validate: value => {
    var regExp = /^\+?[0-9]+$/
    return regExp.test(value)
  },
  message: '{_field_} không đúng định dạng.'
})
extend('password', {
  validate: value => {
    // var regExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$/
    const regExp =
      /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/

    return regExp.test(value)
  },
  message:
    '{_field_} có đội dài tối thiểu 8 kí tự, chứa kí tự in hoa, in thường, số và kí tự đặc biệt.'
})
//   message: '{_field_} 항목은 영문 또는 숫자만 입력 가능합니다.'
// })
// extend('alpha_num_spec', {
//   validate: value => {
//     console.log(value)
//     var regExp = /^[a-zA-Z0-9_]*$/
//     return !!regExp.test(value)
//   },
//   message: '{_field_} 항목은 영문 또는 숫자만 입력 가능합니다.'
// })
extend('integer', {
  ...integer,
  message: '{_field_} phải là số.'
})
extend('percent', {
  validate: value => {
    if (Number(value) > 100 || Number(value) < 0) {
      return false
    } else {
      return true
    }
  },
  message: '{_field_} phải nằm trong khoảng 1-100%'
})
extend('level', {
  validate: value => {
    if (Number(value) > 100 || Number(value) < 0) {
      return false
    } else {
      return true
    }
  },
  message: '{_field_} phải nằm trong khoảng 0-100'
})
extend('positiveNum', {
  validate: value => {
    if (Number(value) < 0) {
      return false
    } else {
      return true
    }
  },
  message: '{_field_} không đúng định dạng'
})
extend('number', {
  validate: value => {
    var regExp = /^[0-9]*$/
    return !!regExp.test(value)
  },
  message: '{_field_} phải là số.'
})
// extend('float', {
//   validate: (value, { precision }) => {
//     value = value.toString()
//     const pos = value.indexOf('.')
//     return pos == -1 || value.substr(pos + 1).length <= precision
//   },
//   params: ['precision'],
//   message: '{_field_}는 소수점 {precision}자리 까지 입력 가능합니다.'
// })
extend('max_byte', {
  validate: (value, { length }) => {
    return (
      value &&
      (function (s, b, i, c) {
        for (
          b = i = 0;
          (c = s.charCodeAt(i++));
          b += c >> 11 ? 3 : c >> 7 ? 2 : 1
        );
        return b
      })(value) <= length
    )
  },
  params: ['length'],
  message: '{_field_} must be no more than {length}byte'
})
extend('confirmed', {
  ...confirmed,
  message: '{_field_} không trùng khớp.'
})
extend('email', {
  ...email,
  message: '{_field_} không hợp lệ.'
})
extend('phoneNumber', {
  validate: (value, { nation, dialCode }) => {
    // console.log('SO DIEN THOAI', value, nation, dialCode)
    if (value === null || value === dialCode) {
      return true
    }
    // console.log(isValidPhoneNumber(value, nation))
    return isValidPhoneNumber(value, nation)
  },
  params: ['nation', 'dialCode'],
  message: '{_field_} không đúng định dạng số điện thoại.'
})
extend('phone', {
  validate: value => {
    var regexPhone = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/
    /* var regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    return regPhone.test(value); */
    // var start = /^\d{2,3}$/
    // var regExp = /^\d{3}-\d{3,4}-\d{4}$/
    // var startStr = value.substr(0, value.indexOf('-'))
    // if (start.test(startStr)) {
    //   regExp = /^\d{2,3}-\d{3,4}-\d{4}$/
    // } else {
    //   regExp = /^\d{3}-\d{3,4}-\d{4}$/
    // }
    // return regExp.test(value) ? true : false;
    // console.log('TRECK SDT: ', value)
    return regexPhone.test(value)
  },
  message: '{_field_} không đúng định dạng số điện thoại.'
})
extend('year', {
  validate: value => {
    const currentYear = Number(moment(new Date()).format('YYYY'))
    if (Number(value) > currentYear || Number(value) < 1900) {
      return false
    } else {
      return true
    }
  },
  message: '{_field_} không đúng định dạng.'
})
extend('min_value', {
  validate: (value, { minValue }) => {
    return +value >= +minValue
  },
  params: ['minValue'],
  message: '{_field_} phải lớn hơn hoặc bằng {minValue}.'
})

extend('max_value', {
  validate: (value, { maxValue }) => {
    return +value <= +maxValue
  },
  params: ['maxValue'],
  message: '{_field_} phải nhỏ hơn hoặc bằng {maxValue}.'
})
// extend('password', {
//   params: ['target'],
//   validate: (value, { target }) => {
//     console.log(value, target)
//     return value === target
//   },
//   message: 'Passwords do not match.'
// })
extend('agree', {
  validate: value => {
    return value
  },
  message: 'Please agree to the {_field_} to proceed.'
})
extend('greater_than_min_visit', {
  validate: (value, { minValue }) => {
    if (!value || !minValue) return true
    return +value > +minValue
  },
  params: ['minValue'],
  message: '{_field_} phải lớn hơn số lần tối thiểu khách đã đến.'
})
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
